import React from 'react';
import './StepProgressBar.css';

const StepProgressBar = ({ currentStep = 0, steps = {}, iconOnly = false }) => {


    function camelCaseToWordsCapitalized(input) {
        return input
            .replace(/([a-z])([A-Z])/g, '$1 $2')
            .replace(/\b\w/g, char => char.toUpperCase());
    }


    const getProgressWidth = () => {
        return ((currentStep) / (totalSteps - 1)) * 100 + '%';
    };
    const stepNames = Object.keys(steps)
    const totalSteps = stepNames.length
    const stepIcons = {
        basicInfo: 'bi-card-text',
        followUp: 'bi-chat-left-dots',
        generatePosts: 'bi-stars',
        ideaSelection: 'bi-lightbulb',
        saveCampaign: 'bi-rocket-takeoff',
        basicDetails: 'bi-building',
        industryInfo: 'bi-briefcase',
        setupProgress: 'bi-stars',
    };

    const getStepIcon = (stepName) => stepIcons[stepName] || 'bi-check2-circle';

    return (
        <div className={`bg-transparent ${iconOnly ? "step-progress-bar--icon-only" : ""}`}>
            <div className="step-wrapper relative mb-4">
                <div
                    className="progress-line"
                    style={{ width: getProgressWidth() }}
                ></div>

                {Array.from({ length: totalSteps }, (_, i) => (
                    <div
                        key={i}
                        className={`step ${i <= currentStep ? 'active' : ''} progress-label text-uppercase`}
                    >
                        <i className={`bi ${getStepIcon(stepNames[i])}`} aria-hidden />
                        {!iconOnly ? (
                            <span className="absolute left-1/2 top-full mt-1 -translate-x-1/2 whitespace-nowrap text-center text-[9px] font-semibold leading-none text-slate-700 md:static md:left-auto md:top-auto md:mt-0 md:ms-2 md:translate-x-0 md:text-[10px] md:text-inherit">
                                {camelCaseToWordsCapitalized(stepNames[i])}
                            </span>
                        ) : null}
                    </div>
                ))}
            </div>

        </div>
    );
};

export default StepProgressBar;
